import { render, staticRenderFns } from "./VidjetAccordion.vue?vue&type=template&id=33b177ba&scoped=true&"
import script from "./VidjetAccordion.vue?vue&type=script&lang=js&"
export * from "./VidjetAccordion.vue?vue&type=script&lang=js&"
import style0 from "./VidjetAccordion.vue?vue&type=style&index=0&id=33b177ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b177ba",
  null
  
)

export default component.exports